/** Компонента редактирование литеральных значений с указанием/заданием языка. 
 * Используется для заполнения аннотирующих свойств, которые могут иметь отдельные языковые константы.
 * 
 * Например, http://purl.org/dc/terms/title, http://www.w3.org/2000/01/rdf-schema#label 
 * 
 * Формирует редактор литерального значения
 * с кнопками:
 * - "Редактировать" значение. По кнопке переходит в режим редактирования.
 * - "Перевод". По кнопке переходит в режим с заданием всех языковых значений
 * - "X" отмена редактирования. По кнопке возвращается предудыщее значение
 * - "ОК" - по кнопке происходит сохранение введённого значения
 *  По Ok создаётся удаляются все триплеты с заданным субъектом и предекатом. А затем
 *     создаётся новый триплет с данными.
*/
import React from 'react';
import i18n from "i18next";
import { connect } from 'react-redux';
import { Tooltip, Button, Form, Row, Col, Input, Modal, message, Select } from 'antd';
import { EditOutlined, MinusOutlined, PlusOutlined, FontSizeOutlined, 
  CloseOutlined, CheckOutlined, MinusCircleOutlined } from '@ant-design/icons'
import { RdfTriplet } from '../../redux';
import { subsetByLang } from '../../virtuoso/helper';

const  uuid = require('uuid');
const ButtonGroup = Button.Group;
const { confirm } = Modal;

/** Компонента, которая обеспечивает одновременный ввод наименование и языка */
class LabelInput extends React.Component {

  handleLabelChange = e => {
    this.triggerChange({ text: e.target.value });
  };

  handleLangChange = lang => {
    this.triggerChange({ lang: lang || '' });
  };

  triggerChange = changedValue => {
    const { onChange, value = {} } = this.props;

    const nextValue = {...value, ...changedValue, };

    if (onChange) 
      onChange(nextValue);
    
  };

  render() {
    const { value = {}, tooltipTitle, buttonIcon, buttonOnClick, languages = [], showFields = true, hasError = false} = this.props;
  return (
    <div style={{ display: 'flex', gap: 8, width: '100%' }}>
      <div style={{ flex: '0 0 32px' }}>
        <Tooltip placement="top" title={tooltipTitle}>
          <Button
            type="dashed"
            size="small"
            icon={buttonIcon}
            onClick={(e) => buttonOnClick(e)}
          />
        </Tooltip>
      </div>

     {showFields && (
      <>
        <div style={{ flex: '1 1 auto', minWidth: 0 }}>
          <Input
            type="text"
            value={value.text}
            onChange={this.handleLabelChange}
            status={hasError ? "error" : undefined}
            placeholder="Наименование"
          />
        </div>

        <div style={{ flex: '0 0 70px' }}>
          <Select
            value={value.lang}
            onChange={this.handleLangChange}
            placeholder="Язык"
            allowClear
            status={hasError ? "error" : undefined}
            style={{ width: '70px' }}
          >
            {languages.map(lang => (
              <Select.Option key={lang} value={lang}>
                {lang}
              </Select.Option>
            ))}
          </Select>
        </div>
      </>
    )}
    </div>
  );
  }
}

/** Форма редактирования литерала без учёта языка */
class AnnotationPropertyEditor extends React.Component {

  state = {
    loading: false,
    operation: "none",		//Состояние операции. none - нет операций, 
      //edit - режим редактирования
      //save - режим сохранения,
      //cancel - режим отмены сохранения,
      //translate - режим перевода
    items: undefined,    //данные в режиме перевода (translate)    
    translateError: undefined, //Ошибка при вводе значений в форме локализации
    canSaveTranslate: false,   //Флаг активности кнопки сохранить результат локализации
    errorItems: {},            //Ошибки валидации 
  }
  
  formRef = React.createRef();

  componentWillReceiveProps(nextProps){
    const { opertaion } = this.state;
    const { selected, predicat } = nextProps;
    if ( opertaion != "none" && selected && selected != predicat) 
      this.setState({operation: "none", items:undefined});
  };

  cancelOperation(){
    this.setState({operation:"none"});
  };

  /** Изменение состава перевода */
  onTranslate(e, type, index){
    e.preventDefault();
    //console.log("AnnotationPropertyEditor.js onTranslate", type, index);
    const {items} = this.state;
    if (type == 'delete'){
        items.splice(index, 1);
        return this.setState({items}, () => this.validateTranslateItems());
    };
    if (type == 'new'){
      const item = {text: "", lang: this.props.lang, id: uuid.v4()};
      return this.setState({items: [ ...items, item ]}, () => this.validateTranslateItems());
    };

  };

  onAction (e, type, value) {
    e.preventDefault();
    const { subject, action, predicat, lang, onReload, values, onInsertLiteral, onDeleteLiteral, onDeleteProperty } = this.props;
    if (type == 'edit'){
      if (action)
        action(e, type, predicat);
      return this.setState({operation:"edit", items: undefined});
    };
    if (type == "save"){
      const form  = this.formRef.current;      
      form.validateFields()
        .then( items => {
          //Получим значение использованное для отображения/редактирования с учётом языка
          const langValues = (Array.isArray(values) && values.length>0)? subsetByLang(values, lang): "";
          const value = (Array.isArray(langValues) && langValues.length>0)? langValues[0].object.value : langValues;
          const valueLang = (Array.isArray(langValues) && langValues.length>0)? langValues[0].object['xml:lang']: undefined;
          //console.log("AnnotationPropertyEditor.js onAction", this, type, subject, predicat, value, valueLang, items, items[predicat]);
          this.setState({operation:"none"});
          Promise.all([
            onInsertLiteral(RdfTriplet, subject, predicat, items[predicat], valueLang),
            onDeleteLiteral(RdfTriplet, subject, predicat, value, valueLang)
          ]).then (result =>{
            //Обновим каталог
            if (onReload)
              onReload(subject, predicat).then(result2=> {
                message.success(i18n.t('components.editor.literal.message.ok_save'));
              });
            else
              message.success("Для просмотра изменений перегрузите страницу.");
          });
        });
    }; //endif if (type == "save"){
    if (type == "update"){
      const form  = this.formRef.current;      
      const { values } = this.props;
      form.validateFields()
        .then( fields => {
          //Удалим new в списке элементов формы
          const {new: _, ...items } = fields; 
          //Переведём исходный данные в удобную для обработки форму
          const wasValues = values.map(item =>  (
            { 
              text: item.object.value, 
              lang: item.object['xml:lang']?item.object['xml:lang']:'',
              item: item
            })
          );
          //Формируем список на удаление. Те, которые есть в values, но нет в items
          const forDelete = wasValues.filter(value => 
            Object.keys(items).filter(key => items[key].lang == value.lang && items[key].text == value.text).length == 0
          );
          //Формируем список на добавление. Те, которые есть в items, но нет в values
          const forInsert = Object.keys(items).filter(key => 
            wasValues.filter(value => items[key].lang == value.lang && items[key].text == value.text).length == 0
          );
          //console.log("AnnotationPropertyEditor.js onAction", this, type, fields, items, values, forDelete, forInsert);
          //Формируем запросы для удаления и добавления
          const requests = forDelete.map(
            item => onDeleteLiteral(RdfTriplet, subject, predicat, item.item.object.value, item.item.object['xml:lang'])
          );
          forInsert.forEach(
            key => requests.push(onInsertLiteral(RdfTriplet, subject, predicat, items[key].text, items[key].lang))
          );
          Promise.all(requests).then (result =>{
            //Обновим каталог
            if (onReload)
              onReload(subject, predicat).then(result2=> {
                message.success(i18n.t('components.editor.literal.message.ok_save'));
              });
            else {
              message.success("Для просмотра изменений перегрузите страницу.");
            };
          });
          this.setState({operation:"none", items: undefined});
        });
    };
    if (type == "cancel"){
      return this.setState({operation:"none", items: undefined});
    }
    if (type == "translate"){
      if (action)
        action(e, type, predicat);
      const items = values.map(item =>  (
        { 
          text: item.object.value, 
          lang : item.object['xml:lang']?item.object['xml:lang']:'',
          id: uuid.v4()
        })
      )
      return this.setState({operation:"translate", items});
    }
    if (type == "delete"){
      confirm(
        { 
          title: 'Удалить свойство', 
          content: "При удалении будут удалены все литеральные данные свойства (включая на других языках)", 
          okText: 'Да', 
          okType: 'danger', 
          cancelText: 'Нет',
          onOk() { 
            onDeleteProperty(RdfTriplet, subject, predicat)
            .then (result =>{
//              if (action) action(e, type, predicat);
              //Обновим каталог
              if (onReload)
                onReload(subject, predicat).then(result2=> {
                  //this.setState({modal:"none"});              
                })
              else{
                message.success("Для просмотра изменений перегрузите страницу.");
              };    
            })
            .catch(info => {
              message.error(i18n.t('components.editor.theme.message.e_unlink', {detail: info}));
              //this.setState({modal:"none"});
            });
                  },
          onCancel() {},
        });
        return;      
    }; //endif if (type == "delete"){
  };


  validateTranslateItems = () => {
    const form = this.formRef.current;

    if (!form)  return;
    
    const values = form.getFieldsValue();

    const formItems = Object.keys(values)
      .filter(key => key !== 'new')
      .map(key => ({
        key,
        text: values[key] && values[key].text ? values[key].text.trim() : '',
        lang: values[key] && values[key].lang ? values[key].lang.trim() : '',
      }));

    const errorItems = {};
    let translateError = undefined;
    let canSaveTranslate = true;

    // Нет элементов
    if (formItems.length === 0) {
      canSaveTranslate = false;
      translateError = 'Добавьте хотя бы одно значение.';
    }

    // Пустые значения
    formItems.forEach(item => {
      if (!item.text) {
        errorItems[item.key] = true;
        canSaveTranslate = false;
        translateError = 'Пожалуйста, укажите значение.';
      }
    });

    const itemsWithLang = formItems.filter(item => item.lang);
    const itemsWithoutLang = formItems.filter(item => !item.lang);

    // Если есть значение без языка, оно должно быть единственным
    if (!translateError && itemsWithoutLang.length > 0) {
      if (formItems.length !== 1) {
        itemsWithoutLang.forEach(item => { errorItems[item.key] = true; });
        canSaveTranslate = false;
        translateError = 'Если значение без языка, оно должно быть единственным.';
      }
    }

    // Если есть хотя бы один язык, то язык должен быть у всех
    if (!translateError && itemsWithLang.length > 0 && itemsWithoutLang.length > 0) {
      itemsWithoutLang.forEach(item => {
        errorItems[item.key] = true;
      });

      canSaveTranslate = false;
      translateError = 'Если хотя бы одно значение указано с языком, язык должен быть указан у всех значений.';
    }

    // Проверка уникальности языков
    if (!translateError && itemsWithLang.length > 0) {
      const langCount = {};

      itemsWithLang.forEach(item => {
        langCount[item.lang] = (langCount[item.lang] || 0) + 1;
      });

      const duplicateLangs = Object.keys(langCount).filter(lang => langCount[lang] > 1);

      if (duplicateLangs.length > 0) {
        formItems.forEach(item => {
          if (duplicateLangs.includes(item.lang)) {
            errorItems[item.key] = true;
          }
        });

        canSaveTranslate = false;
        translateError = 'Для одного языка может быть только одно значение.';
      }
    }

    this.setState({canSaveTranslate, translateError, errorItems});
  };

  render() {
    const { lang, values, predicat, subject, factory, inGroup, languages } = this.props;
    const { operation, items, translateError, errorItems } = this.state;
    const Component = operation == "edit"? factory.ui.getFormItem(predicat): factory.ui.getUIComponent(predicat);
    //Получим значение для отображения/редактирования с учётом языка
    const langValues = (Array.isArray(values) && values.length>0)? subsetByLang(values, lang): "";
    const value = (Array.isArray(langValues) && langValues.length>0)? langValues[0].object.value : langValues;
    const valueLang = (Array.isArray(langValues) && langValues.length>0)? langValues[0].object['xml:lang']: undefined;
    return (
      <span>
        <Row>
        <ButtonGroup>
          {operation == "none" && 
            <Tooltip placement="top" title={"Редактировать"}>
              <Button type="dashed" size="small" icon={<EditOutlined />} onClick={(e)=> this.onAction(e, "edit", values)} />
            </Tooltip>
          }
          {operation == "none" && inGroup.Expert &&
          <Tooltip placement="top" title={"Перевод"}>
              <Button type="dashed" size="small" icon={<FontSizeOutlined />} onClick={(e)=> this.onAction(e, "translate", values)} />
            </Tooltip>
          }
          {(operation == "edit" || operation == "translate") && 
            <Tooltip placement="top" title={"Отменить"}>
              <Button type="dashed" size="small" icon={<CloseOutlined />} onClick={(e)=> this.onAction(e, "cancel")} />
            </Tooltip>
          }
          {operation == "edit" && 
            <Tooltip placement="top" title={"Сохранить"}>
              <Button type="dashed" size="small" icon={<CheckOutlined />} onClick={(e)=> this.onAction(e, "save", value)} />
            </Tooltip>
          }
          {operation == "translate" && inGroup.Expert && 
            <Tooltip placement="top" title={"Сохранить"}>
              <Button type="dashed" size="small" icon={<CheckOutlined />} onClick={(e)=> this.onAction(e, "update", value)}  disabled={!this.state.canSaveTranslate} />
            </Tooltip>
          }
        </ButtonGroup>
        {operation == "translate" && translateError && ( <span style={{ marginLeft: 8, color: '#ff4d4f' }}> {translateError} </span>)}
        <span style={{"display": "flex", "justifyContent": "flex-start", "margin-left": "auto"}}>
        {operation == "edit" && valueLang && <span><i>@{valueLang}</i></span>}
        &nbsp;&nbsp;
        {operation == "edit" &&       
          <Tooltip placement="top" title={"Удалить свойство"}>
            <Button type="dashed" size="small" icon={<MinusCircleOutlined />} 
              onClick={(e)=> this.onAction(e, "delete")}
              style={{"float":"right"}}/>
          </Tooltip>
        }
        </span>
        </Row>
        <Row>
        <Col span={24}>
        {operation == "none" && 
          <Component 
          lang={lang} 
          subject={subject} 
          predicat={predicat} 
          uri={predicat} 
          values={values} 
          factory={factory} 
          />
        }
        {operation == "edit" && 
          <Form ref={this.formRef}>
            <Component 
              lang={lang} 
              subject={subject} 
              predicat={predicat} 
              uri={predicat} 
              value={value} 
              factory={factory} 
              hideLabel={true}
              />
          </Form>
        }
        {operation == "translate" && 
          <Form ref={this.formRef} onValuesChange={this.validateTranslateItems}>
            {items.map((item, i) =>
              <Form.Item key={item.id} name={item.id} initialValue={{ text: item.text, lang: item.lang }} noStyle>
                <LabelInput tooltipTitle={"Удалить"} buttonIcon={<MinusOutlined />} 
                buttonOnClick={(e)=> this.onTranslate(e, "delete", i)} 
                languages={languages}
                hasError={!!errorItems[item.id]} />
              </Form.Item>
            )}
            <div style={{ display: 'flex', marginTop: 8 }}>
              <Tooltip placement="top" title={"Добавить"}>
                <Button
                  type="dashed"
                  size="small"
                  icon={<PlusOutlined />}
                  onClick={(e)=> this.onTranslate(e, "new")}
                />
              </Tooltip>
            </div>
          </Form>
        }    
        </Col>
        </Row>    
      </span>
    );
  };  
};

function mapStateToProps(state, props) {
  const {vselected, vset} = state;
  return {
      vselected,
      inGroup: vset.inGroup,
      languages: vset.languages,
      lang: vset.lang,
  };
}

export default connect(
  mapStateToProps,
  dispatch => ({
    onInsertLiteral(actions, subject, predicat, value, lang=undefined){
      return dispatch(actions.insertTripleLiteral(subject, predicat, value, lang));
    },
    onDeleteLiteral(actions, subject, predicat, value, lang=undefined){
      return dispatch(actions.deleteTripleLiteral(subject, predicat, value, lang));
    },
    onDeleteProperty(actions, subject, predicat){
      return dispatch(actions.deletePredicate(subject, predicat));
    },
  })
)(AnnotationPropertyEditor);